<template>
<div>
    <div class="pc">
        <div class="con-icon"><img src="@/assets/newImages/common/common-icon.png" alt=""></div>
        <div class="content">
            <!-- 标题 -->
            <div class="con-head">
                <p>参会指南</p>
            </div>
            <!-- 二期内容 -->
            <div class="con-guide" :style="{height:pageHeight}">
                <div class="guide">
                    <div class="title" style="display:none;"><div class="p"></div><p>会议地址</p></div>
                    <!-- <div class="map" @click="clickMap()">
                        <img src="@/assets/newImages/home/page8-map1.png" alt="">
                    </div> -->
                    <div class="guide-map" @click="clickMap()">
                        <div class="map">
                            <img src="@/assets/newImages/guide/map.png" alt="">
                        </div>
                        <div class="right-text">
                            <div class="top-bottom" @click.stop="clickResourceOrder()"></div>
                            <div class="text-one">
                                <div class="img"><img src="@/assets/newImages/guide/icon4.png" alt=""></div>
                                <span class="one-span"></span>
                                <div class="one">
                                    <div class="first"><div class="name">1展厅</div><p>专题演讲、伙伴展厅</p></div>
                                    <div class="first"><div class="name">2展厅</div><p>主题演讲</p></div>
                                    <div class="first"><div class="name">3展厅</div><p>展厅</p></div>
                                    <div class="first"><div class="name">4展厅</div><p>展厅</p></div>
                                    <div class="first"><div class="name">5展厅</div><p>VIP休息区、高层会谈区</p></div>
                                    <div class="first"><div class="name">5F/6F</div><p>专题演讲</p></div>
                                    <div class="first"><div class="name">2F</div><p>公共区、互动区</p></div>
                                    <div class="first"><div class="name">北广场</div><p>签到区、安检区</p></div>
                                </div>
                            </div>
                            <div class="text-one">
                                <div class="img"><img src="@/assets/newImages/guide/icon5.png" alt=""></div>
                                <span class="two-span"></span>
                                <div class="second"><div class="name">用餐区</div><p>用餐区 1F/-1F</p></div>
                            </div>
                            <div class="text-one">
                                <div class="img"><img src="@/assets/newImages/guide/icon6.png" alt=""></div>
                                <span class="two-span"></span>
                                <div class="second"><div class="name">步行</div><p>福华三路北入口</p></div>
                            </div>
                            <div class="text-one">
                                <div class="img"><img src="@/assets/newImages/guide/icon7.png" alt=""></div>
                                <span class="two-span"></span>
                                <div class="second"><div class="title">大巴停车区、落客点</div><p>6展厅</p></div>
                            </div>
                            <div class="text-one">
                                <div class="img"><img src="@/assets/newImages/guide/icon8.png" alt=""></div>
                                <span class="two-span"></span>
                                <div class="second"><div class="name">停车</div><p>益田路入口（需持停车证）</p></div>
                            </div>
                            <div class="text-two">
                                <div class="img"><img src="@/assets/newImages/guide/icon9.png" alt=""></div>
                                <span class="three-span"></span>
                                <div class="one">
                                    <div class="first"><div class="name">地铁</div>
                                    <div class="first-p">
                                        <p>1号线：会展中心站 250米 步行5分钟</p>
                                        <p>3号线：购物公园站 410米 步行7分钟</p>
                                        <p>4号线：会展中心站 250米 步行5分钟</p>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="title"><div class="p"></div><p>防疫指南</p></div>
                    <div class="prevent">
                        <p v-for="(item,index) in fangyi" :key="index">{{item}}</p>
                    </div>
                    <div class="title" style="display:none;"><div class="p"></div><p>班车路线</p></div>
                    <div class="route" style="display:none;">
                        <div class="bus" v-for="(route,index) in buses" :key="index">
                            <div class="hotel"><img src="@/assets/newImages/guide/icon.png" alt=""><p>{{route.hotel}}</p></div>
                            <div class="start end"><p>{{route.time}}</p></div>
                            <div class="start"><p>{{route.startSitus1}}</p><span> →</span><p>{{route.endSitus1}}</p></div>
                            <div class="start end" ><p>{{route.time2}}</p></div>
                            <div class="start"><p>{{route.startSitus2}}</p><span> →</span><p>{{route.endSitus2}}</p></div>
                        </div>
                    </div>
                    <div class="title"><div class="p"></div><p>交通指引</p></div>
                    <div class="traffic">
                        <div class="station" v-for="(item,key) in stationList" :key="key">
                            <div class="station-name">
                                <div class="s-img"><div class="img2"><img :src="item.img" alt=""></div></div>
                            </div>
                            <div class="text">
                                <p class="name">{{item.name}}</p>
                                <div class="s-text" v-for="(showOne,index) in item.showOne" :key="index">
                                    <p class="course">{{showOne.start}}——{{showOne.end}}</p>
                                    <div class="show" v-for="(text,textIndex) in showOne.textList" :key="textIndex">
                                        <p class="show-one">{{text}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="title"><div class="p"></div><p>餐厅推荐</p></div>
                    <div class="hall">
                        <div class="dining" v-for="(hall,index) in hallList" :key="index">
                            <div class="hall-img"><img :src="hall.img" alt=""></div>
                            <div class="intro">
                                <p class="intro-name">{{hall.name}}</p>
                                <p class="intros" style="display:none;">{{hall.intro}}</p>
                                <p><span>地址：</span>{{hall.address}}</p>
                                <p><span>距离场馆：</span>{{hall.distance}}</p>
                                <p><span>电话：</span>{{hall.phone}}</p>
                                <p><span>人均：</span>{{hall.price}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            <!-- 三期内容 -->
            <div class="con-guide2" :style="{height:pageHeight}" style="display: none;">
                <div class="guide">
                    <div class="map">
                        <img src="@/assets/newImages/guide/map.png" alt="">
                    </div>
                    <div class="right-text">
                        <div class="text-one">
                            <div class="img"><img src="@/assets/newImages/guide/icon4.png" alt=""></div>
                            <span class="one-span"></span>
                            <div class="one">
                                <div class="first"><div class="name">1展厅</div><p>专题演讲、伙伴展厅</p></div>
                                <div class="first"><div class="name">2展厅</div><p>主题演讲</p></div>
                                <div class="first"><div class="name">3展厅</div><p>展厅</p></div>
                                <div class="first"><div class="name">4展厅</div><p>展厅</p></div>
                                <div class="first"><div class="name">5展厅</div><p>VIP休息区、高层会谈区</p></div>
                                <div class="first"><div class="name">5F/6F</div><p>专题演讲</p></div>
                                <div class="first"><div class="name">2F</div><p>公共区、互动区</p></div>
                                <div class="first"><div class="name">北广场</div><p>签到区、安检区</p></div>
                            </div>
                        </div>
                        <div class="text-one">
                            <div class="img"><img src="@/assets/newImages/guide/icon5.png" alt=""></div>
                            <span class="two-span"></span>
                            <div class="second"><div class="name">用餐区</div><p>用餐区 1F/-1F</p></div>
                        </div>
                        <div class="text-one">
                            <div class="img"><img src="@/assets/newImages/guide/icon6.png" alt=""></div>
                            <span class="two-span"></span>
                            <div class="second"><div class="name">步行</div><p>福华三路北入口</p></div>
                        </div>
                        <div class="text-one">
                            <div class="img"><img src="@/assets/newImages/guide/icon7.png" alt=""></div>
                            <span class="two-span"></span>
                            <div class="second"><div class="title">大巴停车区、落客点</div><p>6展厅</p></div>
                        </div>
                        <div class="text-one">
                            <div class="img"><img src="@/assets/newImages/guide/icon8.png" alt=""></div>
                            <span class="two-span"></span>
                            <div class="second"><div class="name">停车</div><p>益田路入口（需持停车证）</p></div>
                        </div>
                        <div class="text-two">
                            <div class="img"><img src="@/assets/newImages/guide/icon9.png" alt=""></div>
                            <span class="three-span"></span>
                            <div class="one">
                                <div class="first"><div class="name">地铁</div>
                                <div class="first-p">
                                    <p>1号线：会展中心站 250米 步行5分钟</p>
                                    <p>3号线：购物公园站 410米 步行7分钟</p>
                                    <p>4号线：会展中心站 250米 步行5分钟</p>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
    <div class="wap">
        <div class="page-img"><img src="@/assets/newImages/common/navWap/page-img.png" alt=""></div>
            <div class="content">
                <!-- 标题 -->
                <div class="con-header"><p>参会指南</p></div>
                <!-- 二期内容 -->
                <div class="con-main">
                    <div class="guide">
                        <div class="title" style="display:none;"><div class="p"></div><p>会议地址</p></div>
                        <!-- <div class="map" @click="clickMap()">
                            <img src="@/assets/newImages/wap/home/page8-bg1.png" alt="">
                        </div> -->
                        <div class="guide-div" @click="clickMap()">
                            <div class="map">
                                <img src="@/assets/newImages/guide/map.png" alt="">
                            </div>
                            <div class="right-text">
                                <div class="text-one">
                                    <div class="img"><img src="@/assets/newImages/guide/icon4.png" alt=""></div>
                                    <span class="one-span"></span>
                                    <div class="one">
                                        <div class="first"><div class="name">1展厅</div><p>专题演讲、伙伴展厅</p></div>
                                        <div class="first"><div class="name">2展厅</div><p>主题演讲</p></div>
                                        <div class="first"><div class="name">3展厅</div><p>展厅</p></div>
                                        <div class="first"><div class="name">4展厅</div><p>展厅</p></div>
                                        <div class="first"><div class="name">5展厅</div><p>VIP休息区、高层会谈区</p></div>
                                        <div class="first"><div class="name">5F/6F</div><p>专题演讲</p></div>
                                        <div class="first"><div class="name">2F</div><p>公共区、互动区</p></div>
                                        <div class="first"><div class="name">北广场</div><p>签到区、安检区</p></div>
                                    </div>
                                </div>
                                <div class="text-one">
                                    <div class="img"><img src="@/assets/newImages/guide/icon5.png" alt=""></div>
                                    <span class="two-span"></span>
                                    <div class="second"><div class="name">用餐区</div><p>用餐区 1F/-1F</p></div>
                                </div>
                                <div class="text-one">
                                    <div class="img"><img src="@/assets/newImages/guide/icon6.png" alt=""></div>
                                    <span class="two-span"></span>
                                    <div class="second"><div class="name">步行</div><p>福华三路北入口</p></div>
                                </div>
                                <div class="text-one">
                                    <div class="img"><img src="@/assets/newImages/guide/icon7.png" alt=""></div>
                                    <span class="two-span"></span>
                                    <div class="second"><div class="title">大巴停车区、落客点</div><p>6展厅</p></div>
                                </div>
                                <div class="text-one">
                                    <div class="img"><img src="@/assets/newImages/guide/icon8.png" alt=""></div>
                                    <span class="two-span"></span>
                                    <div class="second"><div class="name">停车</div><p>益田路入口（需持停车证）</p></div>
                                </div>
                                <div class="text-two">
                                    <div class="img"><img src="@/assets/newImages/guide/icon9.png" alt=""></div>
                                    <span class="text-two-span"></span>
                                    <div class="one">
                                        <div class="first"><div class="name">地铁</div>
                                            <div class="first-p">
                                                <p>1号线：会展中心站 250米 步行5分钟</p>
                                                <p>3号线：购物公园站 410米 步行7分钟</p>
                                                <p>4号线：会展中心站 250米 步行5分钟</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="top-bottom" @click.stop="clickResourceOrder()"></div>
                            </div>
                        </div>
                        <div class="title"><div class="p"></div><p>防疫指南</p></div>
                        <div class="prevent">
                            <p v-for="(item,index) in fangyi" :key="index">{{item}}</p>
                        </div>
                        <div class="title" style="display:none;"><div class="p"></div><p>班车路线</p></div>
                        <div class="route" style="display:none;">
                            <div class="bus" v-for="(route,index) in buses" :key="index">
                                <div class="hotel"><img src="@/assets/newImages/guide/icon.png" alt=""><p>{{route.hotel}}</p></div>
                                <div class="start end"><p>{{route.time}}</p></div>
                                <div class="start"><p>{{route.startSitus1}}</p><span> →</span><p>{{route.endSitus1}}</p></div>
                                <div class="start end" ><p>{{route.time2}}</p></div>
                                <div class="start"><p>{{route.startSitus2}}</p><span> →</span><p>{{route.endSitus2}}</p></div>
                                
                            </div>
                        </div>
                        <div class="title"><div class="p"></div><p>交通指引</p></div>
                        <div class="traffic">
                            <div class="station" v-for="(item,key) in stationList" :key="key">
                                <div class="station-name">
                                    <div class="s-img"><div class="img2"><img :src="item.img" alt=""></div></div>
                                    <p class="name">{{item.name}}</p>
                                </div>
                                <div class="text">
                                    <div class="s-text" v-for="(showOne,index) in item.showOne" :key="index">
                                        <p class="course">{{showOne.start}}——{{showOne.end}}</p>
                                        <div class="show" v-for="(text,textIndex) in showOne.textList" :key="textIndex">
                                            <p class="show-one">{{text}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="title"><div class="p"></div><p>餐厅推荐</p></div>
                        <div class="hall">
                            <div class="dining" v-for="(hall,index) in hallList" :key="index">
                                <div class="hall-img"><img :src="hall.img" alt=""></div>
                                <div class="intro">
                                    <p class="intro-name">{{hall.name}}</p>
                                    <p class="intros" style="display:none;">{{hall.intro}}</p>
                                    <p><span>地址：</span>{{hall.address}}</p>
                                    <p><span>距离场馆：</span>{{hall.distance}}</p>
                                    <p><span>电话：</span>{{hall.phone}}</p>
                                    <p><span>人均：</span>{{hall.price}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 三期内容 -->
                <div class="con-main2" style="display: none;">
                    <div class="map">
                        <img src="@/assets/newImages/guide/map.png" alt="">
                    </div>
                    <div class="right-text">
                        <div class="text-one">
                            <div class="img"><img src="@/assets/newImages/guide/icon4.png" alt=""></div>
                            <span class="one-span"></span>
                            <div class="one">
                                <div class="first"><div class="name">1展厅</div><p>专题演讲、伙伴展厅</p></div>
                                <div class="first"><div class="name">2展厅</div><p>主题演讲</p></div>
                                <div class="first"><div class="name">3展厅</div><p>展厅</p></div>
                                <div class="first"><div class="name">4展厅</div><p>展厅</p></div>
                                <div class="first"><div class="name">5展厅</div><p>VIP休息区、高层会谈区</p></div>
                                <div class="first"><div class="name">5F/6F</div><p>专题演讲</p></div>
                                <div class="first"><div class="name">2F</div><p>公共区、互动区</p></div>
                                <div class="first"><div class="name">北广场</div><p>签到区、安检区</p></div>
                            </div>
                        </div>
                        <div class="text-one">
                            <div class="img"><img src="@/assets/newImages/guide/icon5.png" alt=""></div>
                            <span class="two-span"></span>
                            <div class="second"><div class="name">用餐区</div><p>用餐区 1F/-1F</p></div>
                        </div>
                        <div class="text-one">
                            <div class="img"><img src="@/assets/newImages/guide/icon6.png" alt=""></div>
                            <span class="two-span"></span>
                            <div class="second"><div class="name">步行</div><p>福华三路北入口</p></div>
                        </div>
                        <div class="text-one">
                            <div class="img"><img src="@/assets/newImages/guide/icon7.png" alt=""></div>
                            <span class="two-span"></span>
                            <div class="second"><div class="title">大巴停车区、落客点</div><p>6展厅</p></div>
                        </div>
                        <div class="text-one">
                            <div class="img"><img src="@/assets/newImages/guide/icon8.png" alt=""></div>
                            <span class="two-span"></span>
                            <div class="second"><div class="name">停车</div><p>益田路入口（需持停车证）</p></div>
                        </div>
                        <div class="text-two">
                            <div class="img"><img src="@/assets/newImages/guide/icon9.png" alt=""></div>
                            <span class="text-two-span"></span>
                            <div class="one">
                                <div class="first"><div class="name">地铁</div>
                                    <div class="first-p">
                                        <p>1号线：会展中心站 250米 步行5分钟</p>
                                        <p>3号线：购物公园站 410米 步行7分钟</p>
                                        <p>4号线：会展中心站 250米 步行5分钟</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</div>
</template>
<script>
import api from '../api';
export default {
    data(){
        return{
            pageHeight:'',
            height:document.documentElement.clientHeight,
            width:document.documentElement.clientWidth,
            buses:[],
            hallList:[],
            fangyi: [],
            stationList:[]
        }
    },
    created(){
        this.pageHeight = this.height-187/1920*this.width-63/1920*this.width+"px"
        this.getData();
    },
    methods: {
        clickMap(){
            window.open(window.$config.url.baiduMap);
            return;
        },
        getData(){
            let that = this;
            api.getGuideContent()
            .then(res=>{
                if(res.fangyi.length>0){
                    that.fangyi = res.fangyi;
                }
                if(res.banche.length>0){
                    that.buses = res.banche;
                }
                if(res.jiaotong.length>0){
                    that.stationList = res.jiaotong;
                }
                if(res.canting.length>0){
                    that.hallList = res.canting;
                }
            })
            .catch(err=>{
            });
        },
        clickResourceOrder(){
            window.open(window.$config.url.resourceOrder);
        },
    }
}
</script>
<style scoped lang="scss">
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.pc{
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url('../assets/newImages/common/common-bg.png')no-repeat center center/cover;
    .con-icon{
        position: absolute;
        right: 0;
        bottom: 0;
        width: pxToVw(480);
        height: pxToVw(403);
        img{
            width: pxToVw(480);
            height: pxToVw(403);
        }
    }
    .content{
        width: pxToVw(1600);
        margin: pxToVw(0) pxToVw(0) 0 pxToVw(233);
        padding-top: pxToVw(49);
        position: relative;
        z-index: 2;
        .con-head{
            width: 100%;
            height: pxToVw(115);
            text-align: left;
            display: flex;
            justify-content: space-between;
            p{  
                width: pxToVw(351);
                height: pxToVw(115);
                padding: pxToVw(36) 0 0 pxToVw(92);
                font-size: pxToVw(43);
                font-family: "FZLT-blackBold";
                color: #FFF;
                line-height: pxToVw(52);
                background: url("../assets/newImages/common/common-title-bg.png")no-repeat center center/cover;
            }
        }
        // 二期内容
        .con-guide{
            
            margin: pxToVw(20) pxToVw(0) pxToVw(0) pxToVw(63);
            padding-right: pxToVw(15);
            overflow-y: scroll;
            scrollbar-width: none;
            -ms-overflow-style: none;
            /*滚动条样式*/
            &::-webkit-scrollbar{
                width: pxToVw(3);
                background: none; 
            }
            &::-webkit-scrollbar-track{
                background: none;
            }
            &::-webkit-scrollbar-thumb{
                background: #DDDDDD;
            }
            .guide{
                height: auto;
                background: RGBA(253, 253, 253, .9);
                box-shadow: 0px 0px pxToVw(27) 0px rgba(231,231,231,0.5);
                padding: pxToVw(12) pxToVw(43) pxToVw(47);
                border-radius: pxToVw(2);
                .title{
                    display: flex;
                    align-items: center;
                    height: pxToVw(30);
                    margin-top: pxToVw(35);
                    .p{
                        width: pxToVw(4);
                        height: pxToVw(21);
                        background: #C50819;
                        border-radius: 3px;
                        margin-top: pxToVw(-5);
                    }
                    p{
                        font-size: pxToVw(24);
                        font-family: "FZLT-blackLittle";
                        font-weight: normal;
                        color: #333333;
                        line-height: pxToVw(30);
                        margin-left: pxToVw(5);
                    }
                }
                // .map{
                //     width: pxToVw(1373);
                //     height: pxToVw(571);
                //     margin-top: pxToVw(29);
                //     background: url('../assets/newImages/home/page8-map1.png')no-repeat center center/cover;
                //     position: relative;
                //     cursor: pointer;
                //     img{
                //         width: 100%;
                //         vertical-align: top;
                //     }
                // }
                .prevent{
                    margin: pxToVw(17) pxToVw(12) 0;
                    display: flex;
                    flex-direction: column;
                    p{
                        font-size: pxToVw(19);
                        font-weight: normal;
                        color: #666666;
                        line-height: pxToVw(32);
                    }
                }
                .route{
                    display: flex;
                    justify-content: space-around;
                    .bus{
                        width: pxToVw(440);
                        // height: pxToVw(232);
                        height: auto;
                        background: #FFFFFF;
                        box-shadow: 0px 0px pxToVw(11) 0px rgba(235,235,235,0.5);
                        border-radius: 3px;
                        padding: pxToVw(24);
                        margin: pxToVw(19) 0 pxToVw(6);
                        .hotel{
                            display: flex;
                            align-items: center;
                            img{
                                width: pxToVw(37);
                                height: pxToVw(37);
                                vertical-align: top;
                            }
                            p{
                                font-size: pxToVw(21);
                                font-weight: normal;
                                color: #333333;
                                line-height: pxToVw(25);
                                margin-left: pxToVw(8);
                            }
                        }
                        .start{
                            display: flex;
                            align-items: center;
                                p{
                                font-size: pxToVw(19);
                                font-weight: normal;
                                color: #666666;
                                line-height: pxToVw(23);
                                letter-spacing: 1px;
                                margin: 0 pxToVw(5);
                                span{
                                    color: #C50819;
                                    line-height: pxToVw(25);
                                }
                            }
                        }
                        .end{
                            margin: pxToVw(16) 0 pxToVw(7);
                        }
                        
                    }
                }
                .traffic{
                    margin-top:pxToVw(17);
                    .station{
                        display: flex;
                        margin-bottom: pxToVw(50);
                        // align-items: center;
                        .station-name{
                           .s-img{
                                width: pxToVw(80);
                                height: pxToVw(80);
                                min-width: pxToVw(80);
                                border: 1px solid #F0F0F0;
                                border-radius: 50%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                .img2{
                                    width: pxToVw(69);
                                    height: pxToVw(69);
                                    min-width: pxToVw(69);
                                    border-radius: 50%;
                                    background: #F0F0F0;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    img{
                                        width: pxToVw(39);
                                        height: pxToVw(31);
                                        vertical-align: top;
                                    }
                                    .image{
                                        width: pxToVw(40);
                                        height: pxToVw(23);
                                        vertical-align: top;
                                    }
                                }
                            } 
                        }
                        .text{
                            margin-left: pxToVw(25);
                            .name{
                                font-size: pxToVw(24);
                                font-weight: normal;
                                font-family: "FZLT-blackLittle";
                                color: #333333;
                                line-height: pxToVw(28);
                                margin-bottom: pxToVw(7);
                            }
                            .s-text{
                                margin-bottom: pxToVw(30);
                                margin-top: pxToVw(10);
                                &:last-child{
                                    margin-bottom: 0;
                                }
                                .course{
                                    color: #333;
                                }
                                .show{
                                    .show-one{
                                        font-size: pxToVw(19);
                                        font-weight: normal;
                                        color: #666;
                                        line-height: pxToVw(29);
                                    } 
                                }
                                
                            }   
                        }
                        
                    }
                }
                .hall{
                    margin-top: pxToVw(24);
                    .dining{
                        display: flex;
                        margin-bottom: pxToVw(20);
                        .hall-img{
                            width: pxToVw(365);
                            height: pxToVw(205);
                            img{
                                width: 100%;
                                min-width: pxToVw(365);
                                vertical-align: top;
                            }
                        }
                        .intro{
                            width: pxToVw(1035);
                            margin-left: pxToVw(33);
                            .intro-name{
                                font-size: pxToVw(24);
                                font-weight: normal;
                                font-family: "FZLT-blackLittle";
                                color: #333333;
                                line-height: pxToVw(28);
                                margin:0 0 pxToVw(17);
                            }
                            .intros{
                                max-height: pxToVw(67);
                                margin-bottom: pxToVw(20);
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                            }
                            p{
                                font-size: pxToVw(19);
                                font-weight: normal;
                                color: #666666;
                                line-height: pxToVw(23);
                                margin-bottom: pxToVw(5);

                                span{
                                    font-family: "FZLT-blackLittle";
                                }
                            }
                        }
                    }
                }
            }
        }
        .guide-map{
            margin: pxToVw(0) 0 0 pxToVw(-47);
            height: auto;
            width: pxToVw(1520);
            border-radius: pxToVw(2);
            display: flex;
            .map{
                width: pxToVw(960);
                height: pxToVw(697);
                cursor: pointer;
                img{
                    width: 100%;
                    min-width: pxToVw(960);
                    vertical-align: top;
                }
            }
            .right-text{
                // width: pxToVw(560);
                position: relative;
                padding: pxToVw(55) pxToVw(31) 0 pxToVw(29);
                .top-bottom{
                    position: absolute;
                    top: 0;
                    right: pxToVw(13);
                    width: pxToVw(160);
                    height: pxToVw(43);
                    cursor: pointer;
                    background: url('../assets/newImages/home/guest/guide-bottom.png') no-repeat center center/cover;
                }
                .img{
                    width: pxToVw(37);
                    height: pxToVw(37);
                    img{
                        width: 100%;
                        vertical-align: top;
                        min-width: pxToVw(37);
                    }
                }
                .text-one{
                    display: flex;
                    align-items: center;
                    margin-bottom: pxToVw(28);
                    span{
                        width: 1px;
                        background: #D8D8D8;
                        margin: 0 pxToVw(27) 0 pxToVw(21);
                    }
                    .one-span{
                        height: pxToVw(212);
                    }
                    .two-span{
                        height: pxToVw(27);
                    }
                    .one{
                        display: flex;
                        flex-direction: column;
                        .first{
                            display: flex;
                            align-items: center;
                            .name{
                                width: pxToVw(84);
                                // margin-right: pxToVw(30);
                                font-size: pxToVw(19);
                                font-family: "FZLT-blackLittle";
                                font-weight: normal;
                                color: #333333;
                                line-height: pxToVw(28);
                            }
                            p{
                                width: pxToVw(209);
                                font-size: pxToVw(19);
                                font-weight: normal;
                                color: #666666;
                                line-height: pxToVw(28);
                            }
                        }
                        
                    }
                    .second{
                        display: flex;
                        align-items: center;
                        .name{
                            width: pxToVw(84);
                            // margin-right: pxToVw(30);
                            font-size: pxToVw(19);
                            font-family: "FZLT-blackLittle";
                            font-weight: normal;
                            color: #333333;
                            line-height: pxToVw(28);
                        }
                        .title{
                            width: pxToVw(188);
                            margin: 0;
                            font-size: pxToVw(19);
                            font-family: "FZLT-blackLittle";
                            font-weight: normal;
                            color: #333333;
                            line-height: pxToVw(28);
                        }
                        p{
                            width: pxToVw(229);
                            font-size: pxToVw(19);
                            font-weight: normal;
                            color: #666666;
                            line-height: pxToVw(28);
                        }
                        
                    }
                }
                .text-two{
                    display: flex;
                    align-items: center;
                    // margin-bottom: pxToVw(28);
                    .three-span{
                        height: pxToVw(77);
                            width: 1px;
                        background: #D8D8D8;
                        margin: 0 pxToVw(27) 0 pxToVw(21);
                    }
                    .one{
                        display: flex;
                        flex-direction: column;
                        .first{
                            display: flex;
                            // align-items: center;
                            .name{
                                width: pxToVw(84);
                                // margin-right: pxToVw(30);
                                font-size: pxToVw(19);
                                font-family: "FZLT-blackLittle";
                                font-weight: normal;
                                color: #333333;
                                line-height: pxToVw(28);
                            }
                            p{
                                width: pxToVw(209);
                                font-size: pxToVw(19);
                                font-weight: normal;
                                color: #666666;
                                line-height: pxToVw(28);
                            }
                            .first-p{
                                width: pxToVw(329);
                                display: flex;
                                flex-direction: column;
                                p{
                                    width: auto;
                                    font-size: pxToVw(19);
                                    font-weight: normal;
                                    color: #666666;
                                    line-height: pxToVw(28); 
                                }
                            }
                        }
                        
                    }
                }
            }
        }
        // 三期内容
        .con-guide2{
            margin: pxToVw(27) pxToVw(0) pxToVw(0) pxToVw(63);
            .guide{
                height: auto;
                background: RGBA(253, 253, 253, .9);
                box-shadow: 0px 0px pxToVw(27) 0px rgba(231,231,231,0.5);
                border-radius: pxToVw(2);
                display: flex;
                .map{
                    width: pxToVw(960);
                    height: pxToVw(697);
                    img{
                        width: 100%;
                        min-width: pxToVw(960);
                        vertical-align: top;
                    }
                }
                .right-text{
                    // width: pxToVw(560);
                    padding: pxToVw(48) pxToVw(31) 0 pxToVw(29);
                    .img{
                        width: pxToVw(37);
                        height: pxToVw(37);
                        img{
                            width: 100%;
                            vertical-align: top;
                            min-width: pxToVw(37);
                        }
                    }
                    .text-one{
                        display: flex;
                        align-items: center;
                        margin-bottom: pxToVw(28);
                        span{
                            width: 1px;
                            background: #D8D8D8;
                            margin: 0 pxToVw(27) 0 pxToVw(21);
                        }
                        .one-span{
                            height: pxToVw(212);
                        }
                        .two-span{
                            height: pxToVw(27);
                        }
                        .one{
                            display: flex;
                            flex-direction: column;
                            .first{
                                display: flex;
                                align-items: center;
                                .name{
                                    width: pxToVw(84);
                                    // margin-right: pxToVw(30);
                                    font-size: pxToVw(19);
                                    font-family: "FZLT-blackLittle";
                                    font-weight: normal;
                                    color: #333333;
                                    line-height: pxToVw(28);
                                }
                                p{
                                    width: pxToVw(209);
                                    font-size: pxToVw(19);
                                    font-weight: normal;
                                    color: #666666;
                                    line-height: pxToVw(28);
                                }
                            }
                            
                        }
                        .second{
                            display: flex;
                            align-items: center;
                            .name{
                                width: pxToVw(84);
                                // margin-right: pxToVw(30);
                                font-size: pxToVw(19);
                                font-family: "FZLT-blackLittle";
                                font-weight: normal;
                                color: #333333;
                                line-height: pxToVw(28);
                            }
                            .title{
                                width: pxToVw(188);
                                // margin-right: pxToVw(30);
                                font-size: pxToVw(19);
                                font-family: "FZLT-blackLittle";
                                font-weight: normal;
                                color: #333333;
                                line-height: pxToVw(28);
                            }
                            p{
                                width: pxToVw(229);
                                font-size: pxToVw(19);
                                font-weight: normal;
                                color: #666666;
                                line-height: pxToVw(28);
                            }
                            
                        }
                    }
                    .text-two{
                        display: flex;
                        align-items: center;
                        // margin-bottom: pxToVw(28);
                        .three-span{
                            height: pxToVw(77);
                             width: 1px;
                            background: #D8D8D8;
                            margin: 0 pxToVw(27) 0 pxToVw(21);
                        }
                        .one{
                            display: flex;
                            flex-direction: column;
                            .first{
                                display: flex;
                                // align-items: center;
                                .name{
                                    width: pxToVw(84);
                                    // margin-right: pxToVw(30);
                                    font-size: pxToVw(19);
                                    font-family: "FZLT-blackLittle";
                                    font-weight: normal;
                                    color: #333333;
                                    line-height: pxToVw(28);
                                }
                                p{
                                    width: pxToVw(209);
                                    font-size: pxToVw(19);
                                    font-weight: normal;
                                    color: #666666;
                                    line-height: pxToVw(28);
                                }
                                .first-p{
                                    width: pxToVw(329);
                                    display: flex;
                                    flex-direction: column;
                                    p{
                                        width: auto;
                                       font-size: pxToVw(19);
                                        font-weight: normal;
                                        color: #666666;
                                        line-height: pxToVw(28); 
                                    }
                                }
                            }
                            
                        }
                    }
                }
            }
        }
    }
}
.wap{
    display: none;
}
@media screen and (max-width:767px) {
    .pc{
        display: none;
    }
    .wap{
        display: block;
        position: relative;
        z-index: 2;
        width: 100%;
        height: auto;
        min-height: 100vh;
        padding: 10vw 0 13.3vw;
        background: url('../assets/newImages/exhibitionGuide/wap-bg.png')no-repeat center center/cover;
        .page-img{
            position: absolute;
            bottom: 0;
            z-index: -1;
            right: 0;
            width: 38.1vw;
            height: 25.1vw;
            img{
                width: 38.1vw;
                height: 25.1vw;
            }
        }
        .content{
            width: 100%;
            border-top: 1px solid #DDDDDD;
            .con-header{
                height: 12.3vw;
                margin: 3.2vw 0 2.3vw;
                width: 100%;
                text-align: left;
                p{  
                    width: 37.6vw;
                    height: 12.3vw;
                    margin-left: -2.8vw;
                    padding: 4.1vw 0 0 10vw;
                    font-size: 4.3vw;
                    font-family: "FZLT-blackBold";
                    color: #FFF;
                    line-height: 5.2vw;
                    background: url("../assets/newImages/common/navWap/page-title.png") no-repeat center center/cover;
                }
            }
            .con-main{
                width: 90.9vw;
                margin:2.3vw auto 0;
                background: rgba(255, 255, 255, .7);
                padding: 6.8vw 3.7vw 11.3vw;
                .guide{
                    // width: 90.9vw;
                    height: auto;
                    .title{
                        display: flex;
                        align-items: center;
                        height: 4vw;
                        // margin-top: pxToVw(35);
                        .p{
                            width: 0.6vw;
                            height: 3vw;
                            background: #C50819;
                            border-radius: 0.4vw;
                            // margin-top: pxToVw(-5);
                        }
                        p{
                            font-size: 3.5vw;
                            font-family: "FZLT-blackLittle";
                            font-weight: normal;
                            color: #333333;
                            line-height: 4vw;
                            margin-left: 1.5vw;
                        }
                    }
                    // .map{
                    //     width: 83.5vw;
                    //     height: 51.3vw;
                    //     margin: 2.3vw auto 9.1vw;
                    //     cursor: pointer;
                    //     img{
                    //         width: 100%;
                    //         height: 100%;
                    //         vertical-align: top;
                    //         cursor: pointer;
                    //     }
                    // }
                    .prevent{
                        margin: 2.7vw 0 5.2vw;
                        display: flex;
                        flex-direction: column;
                        p{
                            font-size: 3.2vw;
                            font-weight: normal;
                            color: #666666;
                            line-height: 4.8vw;
                        }
                    }
                    .route{
                        display: flex;
                        // justify-content: space-around;
                        flex-direction: column;
                        margin: 1.7vw 0 5.4vw;
                        .bus{
                            width: 83.5vw;
                            // height: 34.8vw;
                            height: auto;
                            background: #FFFFFF;
                            box-shadow: 0px 0px 1.6vw 0px rgba(235,235,235,0.5);
                            border-radius: 0.4vw;
                            padding: 3.6vw;
                            margin: 0 0 2.7vw;
                            .hotel{
                                display: flex;
                                align-items: center;
                                img{
                                    width: 5.6vw;
                                    height: 5.6vw;
                                    vertical-align: top;
                                }
                                p{
                                    font-size: 3.2vw;
                                    font-weight: normal;
                                    color: #333333;
                                    line-height: 3.7vw;
                                    font-family: "FZLT-blackLittle";
                                    margin-left: 1.2vw;
                                }
                            }
                            .start{
                                display: flex;
                                align-items: center;
                                    p{
                                    font-size: 3.2vw;
                                    font-weight: normal;
                                    color: #666666;
                                    line-height: 3.6vw;
                                    letter-spacing: 1px;
                                    margin: 0 1vw;
                                    span{
                                        color: #C50819;
                                        line-height: 3.6vw;

                                    }
                                }
                            }
                            .end{
                                margin: 2.1vw 0 1.3vw;
                            }
                            
                        }
                    }
                    .traffic{
                        margin-top:3.2vw;
                        .station{
                            display: flex;
                            flex-direction: column;
                            margin-bottom: 4vw;
                            // align-items: center;
                            .station-name{
                                display: flex;
                                align-items: center;
                                .s-img{
                                    width: 8vw;
                                    height: 8vw;
                                    min-width: 8vw;
                                    border: 1px solid #F0F0F0;
                                    border-radius: 50%;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    .img2{
                                        width: 6.9vw;
                                        height: 6.9vw;
                                        min-width: 6.9vw;
                                        border-radius: 50%;
                                        background: #F0F0F0;
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        img{
                                            width: 3.9vw;
                                            height: 3.1vw;
                                            vertical-align: top;
                                        }
                                        .image{
                                            width: 4vw;
                                            height: 2.3vw;
                                            vertical-align: top;
                                        }
                                    }
                                }
                                .name{
                                    font-size: 3.2vw;
                                    font-weight: normal;
                                    font-family: "FZLT-blackLittle";
                                    color: #333333;
                                    line-height: 4.8vw;
                                    margin-left: 2.3vw;
                                } 
                            }
                            .text{
                                margin-top: 1.2vw;
                                .s-text{
                                    margin-bottom: 4vw;
                                    &:last-child{
                                        margin-bottom: 0;
                                    }
                                    .course{
                                        color: #333;
                                    }
                                    // .course2{
                                    //     margin-top: 3vw;
                                    // }
                                    p{
                                        font-size: 3.2vw;
                                        font-weight: normal;
                                        color: #666;
                                        line-height: 4.8vw;
                                        margin-bottom: 1vw;
                                    }
                                }
                            }
                        }
                    }
                    .hall{
                        margin-top: 1.7vw;
                        .dining{
                            margin-bottom: 2.7vw;
                            &:last-child{
                                margin-bottom: 0;

                            }
                            .hall-img{
                                width: 83.5vw;
                                height: 46.9vw;
                                img{
                                    width: 100%;
                                    min-width: 83.5vw;
                                    vertical-align: top;
                                }
                            }
                            .intro{
                                margin-top: 3.2vw;
                                .intro-name{
                                    font-size: 3.2vw;
                                    font-weight: normal;
                                    font-family: "FZLT-blackLittle";
                                    color: #333333;
                                    line-height: 3.7vw;
                                    margin:0 0 1.7vw;
                                }
                                .intros{
                                    height: 14.4vw;
                                    margin-bottom: 2vw;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 3;
                                    -webkit-box-orient: vertical;
                                }
                                p{
                                    font-size: 3.2vw;
                                    font-weight: normal;
                                    color: #666666;
                                    line-height: 4.8vw;
                                    span{
                                        font-family: "FZLT-blackLittle";
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .guide-div{
                width: 90.7vw;
                margin:4vw 0 0 -3.7vw;
                padding-bottom: 5vw;
                .map{
                    width: 88vw;
                    height: 63.9vw;
                    margin: 0.9vw auto;
                    cursor: pointer;
                    img{
                        width: 100%;
                        vertical-align: top;
                    }
                }
                .right-text{
                    // width: pxToVw(560);
                    margin: 3.7vw 0 3.7vw 4.5vw;
                    .img{
                        width: 5.6vw;
                        height: 5.6vw;
                        img{
                            width: 100%;
                            vertical-align: top;
                            min-width: 5.6vw;
                        }
                    }
                    .text-one{
                        display: flex;
                        align-items: center;
                        margin-bottom: 2.8vw;
                        span{
                            width: 0.2vw;
                            background: #D8D8D8;
                            margin: 0 4vw 0 3.2vw;
                        }
                        .one-span{
                            height: 31.8vw;
                        }
                        .two-span{
                            width: 0.2vw;
                            height: 4vw;
                        }
                        .one{
                            display: flex;
                            flex-direction: column;
                            .first{
                                display: flex;
                                align-items: center;
                                .name{
                                    width: 13.2vw;
                                    // margin-right: pxToVw(30);
                                    font-size: 3.2vw;
                                    font-family: "FZLT-blackLittle";
                                    font-weight: normal;
                                    color: #333333;
                                    line-height: 4.8vw;
                                }
                                p{
                                    width: 39vw;
                                    font-size: 3.2vw;
                                    font-weight: normal;
                                    color: #666666;
                                    line-height: 4.8vw;
                                }
                            }
                            
                        }
                        .second{
                            display: flex;
                            align-items: center;
                            .name{
                                width: 13.2vw;
                                // margin-right: pxToVw(30);
                                font-size: 3.2vw;
                                font-family: "FZLT-blackLittle";
                                font-weight: normal;
                                color: #333333;
                                line-height: 4.8vw;
                            }
                            .title{
                                width: 32vw;
                                // margin-right: pxToVw(30);
                                font-size: 3.2vw;
                                font-family: "FZLT-blackLittle";
                                font-weight: normal;
                                color: #333333;
                                line-height: 4.8vw;
                            }
                            p{
                                width: 39vw;
                                font-size: 3.2vw;
                                font-weight: normal;
                                color: #666666;
                                line-height: 4.8vw;
                            }
                            
                        }
                    }
                    .text-two{
                        display: flex;
                        align-items: center;
                        .text-two-span{
                            width: 0.2vw;
                            height: 11.6vw;
                            background: #D8D8D8;
                            margin: 0 4vw 0 3.2vw;
                        }
                        .one{
                            display: flex;
                            flex-direction: column;
                            .first{
                                display: flex;
                                .name{
                                    width: 13.2vw;
                                    // margin-right: pxToVw(30);
                                    font-size: 3.2vw;
                                    font-family: "FZLT-blackLittle";
                                    font-weight: normal;
                                    color: #333333;
                                    line-height: 4.8vw;
                                }
                                p{
                                    width: 56vw;
                                    font-size: 3.2vw;
                                    font-weight: normal;
                                    color: #666666;
                                    line-height: 4.8vw;
                                }
                            }
                            
                        }
                    }
                    .top-bottom{
                        width: 24vw;
                        height: 6.4vw;
                        margin: 4.3vw 33.3vw 0 28.8vw;
                        background: url('../assets/newImages/home/guest/guide-bottom.png') no-repeat center center/cover;
                    }
                }
            }
            // 三期
            .con-main2{
                width: 90.7vw;
                margin:4vw auto 0;
                padding-bottom: 9.6vw;
                background: rgba(255, 255, 255, .7);
                // padding: 6.8vw 3.7vw 11.3vw;
                .map{
                    width: 88vw;
                    height: 63.9vw;
                    margin: 0.9vw auto;
                    img{
                        width: 100%;
                        vertical-align: top;
                    }
                }
                .right-text{
                    // width: pxToVw(560);
                    margin: 3.7vw 0 3.7vw 4.5vw;
                    .img{
                        width: 5.6vw;
                        height: 5.6vw;
                        img{
                            width: 100%;
                            vertical-align: top;
                            min-width: 5.6vw;
                        }
                    }
                    .text-one{
                        display: flex;
                        align-items: center;
                        margin-bottom: 2.8vw;
                        span{
                            width: 0.2vw;
                            background: #D8D8D8;
                            margin: 0 4vw 0 3.2vw;
                        }
                        .one-span{
                            height: 31.8vw;
                        }
                        .two-span{
                            width: 0.2vw;
                            height: 4vw;
                        }
                        .one{
                            display: flex;
                            flex-direction: column;
                            .first{
                                display: flex;
                                align-items: center;
                                .name{
                                    width: 13.2vw;
                                    // margin-right: pxToVw(30);
                                    font-size: 3.2vw;
                                    font-family: "FZLT-blackLittle";
                                    font-weight: normal;
                                    color: #333333;
                                    line-height: 4.8vw;
                                }
                                p{
                                    width: 39vw;
                                    font-size: 3.2vw;
                                    font-weight: normal;
                                    color: #666666;
                                    line-height: 4.8vw;
                                }
                            }
                            
                        }
                        .second{
                            display: flex;
                            align-items: center;
                            .name{
                                width: 13.2vw;
                                // margin-right: pxToVw(30);
                                font-size: 3.2vw;
                                font-family: "FZLT-blackLittle";
                                font-weight: normal;
                                color: #333333;
                                line-height: 4.8vw;
                            }
                            .title{
                                width: 32vw;
                                // margin-right: pxToVw(30);
                                font-size: 3.2vw;
                                font-family: "FZLT-blackLittle";
                                font-weight: normal;
                                color: #333333;
                                line-height: 4.8vw;
                            }
                            p{
                                width: 39vw;
                                font-size: 3.2vw;
                                font-weight: normal;
                                color: #666666;
                                line-height: 4.8vw;
                            }
                            
                        }
                    }
                    .text-two{
                        display: flex;
                        align-items: center;
                        .text-two-span{
                            width: 0.2vw;
                            height: 11.6vw;
                            background: #D8D8D8;
                            margin: 0 4vw 0 3.2vw;
                        }
                        .one{
                            display: flex;
                            flex-direction: column;
                            .first{
                                display: flex;
                                .name{
                                    width: 13.2vw;
                                    // margin-right: pxToVw(30);
                                    font-size: 3.2vw;
                                    font-family: "FZLT-blackLittle";
                                    font-weight: normal;
                                    color: #333333;
                                    line-height: 4.8vw;
                                }
                                p{
                                    width: 56vw;
                                    font-size: 3.2vw;
                                    font-weight: normal;
                                    color: #666666;
                                    line-height: 4.8vw;
                                }
                            }
                            
                        }
                    }
                }
            }
        }
    }
}
</style>